import React from "react";
import DataTable from "react-data-table-component";

import { useSidebarLayoutContext } from "contexts/SidebarLayoutContext";

import TableLoader from "./TableLoader";
import EmptyResult from "../Lottie/EmptyResult";

import { useTablePagination } from "hooks";

const AppTable = ({ paginationPerPage = 10, ...props }) => {
  const { darkMode, theme } = useSidebarLayoutContext();

  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination(paginationPerPage);

  const tablePaginationProps = {
    paginationServer: true,
    paginationDefaultPage: currentPage || 1,
    paginationPerPage: perPage || 10,
    onChangePage: handlePageChange,
    onChangeRowsPerPage: handlePerRowsChange,
  };

  const customStyles = {
    rows: {
      style: {
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
  };

  return (
    <DataTable
      pagination
      paginationRowsPerPageOptions={[10, 20, 50, 100]}
      progressComponent={<TableLoader />}
      noDataComponent={<EmptyResult height={200} />}
      persistTableHead={true}
      theme={darkMode ? "dark" : "default"}
      {...{ customStyles, ...tablePaginationProps, ...props }}
    />
  );
};

export default AppTable;
